import { BaseLoginService } from '../../../../../../coverpath-common/angular/services/login/base-login.service';
import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { AmorphicService } from '../../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { CoverpathUtils } from '../../../../../../coverpath-common/js/static/CoverpathUtils';
import { AuthenticationService } from '../../../../../../coverpath-common/angular/services/authentication/authentication.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    moduleId: module.id,
    selector: 'page-header',
    templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {
    private readonly destroy$ = new Subject<void>();
    controller;
    showHamburger: boolean;
    routeIsHome: boolean;
    routeIsFaq: boolean;
    routeIsLifeBridge: boolean;

    constructor(amorphicService: AmorphicService,
                private router: Router,
                private location: Location,
                private authenticationService: AuthenticationService) {
        this.controller = amorphicService.controller;
        this.showHamburger = false;
    }

    ngOnInit(): void {
        this.routeUpdated();
        this.router.events.pipe(takeUntil(this.destroy$)).subscribe(_ => this.routeUpdated());
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private routeUpdated(): void {
        if(this.location.path() !== '') {
            this.routeIsHome = this.router.url.includes('home');
            this.routeIsFaq = this.router.url.includes('faq');
            this.routeIsLifeBridge = this.router.url.includes('lifebridge');
        }
    }

    hideHamburger(): void {
        this.showHamburger = false;
    }

    toggleHamburger(): void {
        this.showHamburger = !this.showHamburger;
    }

    scrollToQuickQuote(): void {
        CoverpathUtils.scrollToElement('quick-quote');
    }

    login(): void {
        this.authenticationService.goToLogin();
    }

    logout(): void {
        this.authenticationService.logout();
    }
}
